<template>
  <v-dialog @click:outside="onCancelled" value="true">
    <v-card color="white" class="description-container">
      <slot></slot>
      <div class="action-container">
        <baseButton
          white
          :value="$t('confirmation-dialog.cancel')"
          :action="onCancelled"
        />
        <baseButton
          :value="$t('confirmation-dialog.confirm')"
          :action="onConfirmed"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import baseButton from '../components/base-button'

export default {
  components: {
    baseButton
  },
  props: {
    onConfirmed: { type: Function, required: true },
    onCancelled: { type: Function, required: true }
  }
}
</script>

<style>
.v-dialog {
  width: auto !important;
  border: 1px solid rgba(0, 0, 0, 0.7);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
}

.description-container {
  width: 514px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.action-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

</style>
